import getLinkHref from '@/modules/utils/api/getLinkHref'
import clientHTTP from '@/modules/clientHTTP'

/**
* BSC
*/

const getCustomersLastEventsCounters = (application, options) => {
  return clientHTTP.get(getLinkHref(application, 'customersLastEventsCounters'), {}, {}, options)
}

const getFleetLastEvents = (fleet, params = {}) => {
  return clientHTTP.get(getLinkHref(fleet, 'fleetLastEvents'), params)
}

const getFleetLastEventsCounters = (fleet) => {
  return clientHTTP.get(getLinkHref(fleet, 'fleetLastEventsCounters'))
}

/**
 * LNS
 */

const getLnsCustomersLastEventsCounters = (application, options) => {
  return clientHTTP.get(getLinkHref(application, 'lnsCustomersLastEventsCounters'), {}, {}, options)
}

const getClusterLastEvents = (cluster, params = {}) => {
  return clientHTTP.get(getLinkHref(cluster, 'clusterLastEvents'), params)
}

/**
* RNC
*/

const getRncCustomersLastEventsCounters = (application, options) => {
  return clientHTTP.get(getLinkHref(application, 'rncCustomersLastEventsCounters'), {}, {}, options)
}

const getRncGatewaysLastEvents = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'rncGatewaysLastEvents'), params)
}

/**
* COMMON
*/

// Works for gateway, end-device and network alarms
const patchLastEvent = (alarm, params = {}) => {
  return clientHTTP.patch(getLinkHref(alarm, 'self'), params)
}

export default {
  // BSC
  getCustomersLastEventsCounters,
  getFleetLastEvents,
  getFleetLastEventsCounters,
  // LNS
  getLnsCustomersLastEventsCounters,
  getClusterLastEvents,
  // RNC
  getRncCustomersLastEventsCounters,
  getRncGatewaysLastEvents,
  // COMMON
  patchLastEvent
}
